import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CommonConstants,
  EndpointKeysCommon,
  IDP_APPS,
  Libraries
} from '@com-delta-idp/mnx-skymiles-shared';
import {
  ApiBuilder,
  AppConfigService,
  CustomErrorBase,
  CustomErrorVariant,
  HttpRequestMethods,
  handleError,
  logCustomError
} from '@com-delta-idp/mnx-utils';
import { Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  PartnersPersonalizationEngineRequest,
  PartnersPersonalizationEngineResponse
} from '../models/partners-personalization-engine.interfaces';

@Injectable({
  providedIn: 'root'
})
export class PersonalizationEngineService {
  errorHandler = handleError.bind(this);

  constructor(private http: HttpClient, private appConfig: AppConfigService) {}

  getPartnersContent = (
    request: PartnersPersonalizationEngineRequest
  ): Observable<PartnersPersonalizationEngineResponse> =>
    new ApiBuilder<
      PartnersPersonalizationEngineRequest,
      PartnersPersonalizationEngineResponse
    >(this.http, this.appConfig)
      .app(IDP_APPS.COMMON)
      .endpointKey(EndpointKeysCommon['GET_PERSONALIZED_CONTENT_URL'])
      .method(HttpRequestMethods['POST'])
      .payload(request)
      .timeOut(CommonConstants.TIMEOUT)
      .errorHandler(this.errorHandler)
      .library(Libraries.PARTNERS)
      .create()
      .pipe(
        map((response: PartnersPersonalizationEngineResponse) => {
          return this.existCustomError(response);
        })
      );

  existCustomError(
    response: PartnersPersonalizationEngineResponse | CustomErrorVariant
  ): PartnersPersonalizationEngineResponse {
    if ('error' in response) {
      const error: CustomErrorBase = {
        code: response.error.errorCode,
        message: response.error.errorMessage,
        developerMessage: ''
      };

      logCustomError(
        error,
        IDP_APPS.COMMON,
        Libraries.PARTNERS,
        EndpointKeysCommon.GET_PERSONALIZED_CONTENT_URL
      );
      throw throwError(response);
    }
    return response;
  }
}
